import { render, staticRenderFns } from "./CreateBuyerModal.vue?vue&type=template&id=72b5dc3c&"
import script from "./CreateBuyerModal.vue?vue&type=script&lang=js&"
export * from "./CreateBuyerModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateBuyerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports